import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { publicApi, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function GoogleCallback() {
  const { hash, pathname } = useLocation();
  const nav = useNavigate();
  const { loginParent } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    const next = pathname === "/parent" ? "/parent" : "/profiles";
    if (!sessionId) return nav("/login", { replace: true });
    publicApi.post("/auth/google/session", { session_id: sessionId }).then(({ data }) => {
      if (data.status === "consent_required") return nav("/google-consent", { replace: true, state: { ticket: data.ticket, name: data.name, email: data.email } });
      loginParent(data);
      nav(next, { replace: true });
    }).catch((e) => {
      toast.error(errMsg(e));
      nav("/login", { replace: true });
    });
  }, [hash, pathname, nav, loginParent]);

  return <div data-testid="google-callback" className="min-h-screen grid place-items-center font-display text-2xl">Signing you in…</div>;
}
